// stores/dashboardStore.js
import { defineStore } from 'pinia'
import { useUserStore } from './userStore'
import * as companyApi from '@/api/companyApi.js'
import * as projectApi from '@/api/projectApi.js'
import * as dashboardApi from '@/api/dashboardApi.js'

const SPACE_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
}

export const useDashboardStore = defineStore('dashboard', {
    state: () => ({
        spaces: [],
        stats: [],
        status: SPACE_STATUS.ACTIVE,
        loading: false,
        error: null,
        _authStore: null,
        _initialized: false
    }),
    getters: {
        isLoading: (state) => state.loading,
        getError: (state) => state.error,
        isInitialized: (state) => state._initialized
    },
    actions: {
        async init() {
            if (this._initialized) return
            
            this._authStore = useUserStore()
            
            try {
                this.loading = true;
                
                await Promise.all([
                    this.fetchSpaces(this.status)
                ])
                this._initialized = true
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },        
        async setStatus(status) {
            if (!Object.values(SPACE_STATUS).includes(status)) {
                throw new Error(`Invalid status: ${status}`)
            }
            this.status = status
            await this.fetchSpaces()
        },            
        async fetchSpaces() {
            if (!this._authStore) this.init()
            try {
                this.loading = true
                let response = []

                switch (this.status) {
                    case SPACE_STATUS.ACTIVE:
                        response = await dashboardApi.listSpaces(this._authStore.token)
                        this.spaces = response
                        break
                    case SPACE_STATUS.ARCHIVED:
                        //response = await dashboardApi.listArchivedSpaces(this._authStore.token)
                        //this.spaces = response
                        break
                    case SPACE_STATUS.DELETED:
                        //response = await dashboardApi.listDeletedSpaces(this._authStore.token)
                        //this.spaces = response
                        break
                    default:
                        throw new Error('Invalid status')
                }
                return response
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },             
        async fetchUserStats() {
            if (!this._authStore) this.init()
            try {
                this.loading = true;
                const response = await dashboardApi.userStats(this._authStore.token);
                this.stats = response;
                return response;
            } catch (error) {
                this.error = error;
                throw error;
            } finally {
                this.loading = false;
            }
        },     
        async updateSpace(data) {
            if (!this._authStore) this.init()
            try {
                this.loading = true
                const response = await companyApi.updateCompany(this._authStore.token, data)
                await this.fetchSpaces()
                return response
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },
        async archiveSpace(data) {
            if (!this._authStore) this.init()
            try {
                this.loading = true
                const response = await companyApi.archCompany(this._authStore.token, data)
                await this.fetchSpaces()
                return response
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },         
        async deleteSpace(id) {
            if (!this._authStore) this.init()
            try {
                this.loading = true
                const response = await companyApi.delCompany(this._authStore.token, id)
                await this.fetchSpaces()
                return response
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },        
        async projectInfo(id) {
            try {
                this.loading = true;
                const response = await dashboardApi.projectInfo(this._authStore.token, id);
                return response;
            } catch (error) {
                this.error = error;
                throw error;
            } finally {
                this.loading = false;
            }            
        },
        async projectTeam(id) {
            try {
                this.loading = true;
                const response = await dashboardApi.projectTeam(this._authStore.token, id);
                return response;
            } catch (error) {
                this.error = error;
                throw error;
            } finally {
                this.loading = false;
            }            
        },        
        async archiveProject(id) {
            if (!this._authStore) this.init()
            try {
                this.loading = true
                const response = await projectApi.archProject(this._authStore.token, id)
                await this.fetchSpaces()
                return response
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },         
        async deleteProject(id) {
            if (!this._authStore) this.init()
            try {
                this.loading = true
                const response = await projectApi.archProject(this._authStore.token, id)
                await this.fetchSpaces()
                return response
            } catch (error) {
                this.error = error
                throw error
            } finally {
                this.loading = false
            }
        },         
    },
})